export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE';
export const RESET_FILTER_VALUE = 'RESET_FILTER_VALUE';

export const setFilterValue = ({ filtersGroupId, filterId, value }) => ({
  type: CHANGE_FILTER_VALUE,
  payload: { filtersGroupId, filterId, value },
});

export const resetFilterValue = ({ filtersGroupId, filterId }) => ({
  type: RESET_FILTER_VALUE,
  payload: { filtersGroupId, filterId },
});
